import { useAtomValue } from 'jotai'
import * as R from 'ramda'
import { FC } from 'react'
import { Link } from 'react-router-dom'

import packageJson from '../../package.json'
import { routeParams } from '../@types/route'
import { settingsState } from '../atoms/settingsState'

export const TopLinker: FC = () => {
  const {
    selector,
    grade,
    version: settingsVersion,
  } = useAtomValue(settingsState)

  const tdClassName = 'border border-slate-200 text-sm py-3 px-3'

  return (
    <div className="p-1">
      {/* <table className="m-5" style={{ width: '100%' }}> */}
      <table style={{ width: '100%' }}>
        <tbody>
          {selector.map((aSelector, index) => {
            let addClassName = ''
            if (index % 2 === 0) {
              addClassName = ' bg-gray-50'
            }
            const lowerData = R.toLower(aSelector.id)
            const uppperData = R.toUpper(aSelector.id)
            const jumpPass = `/${lowerData}`

            const render1234 = (grade: string) => {
              const params: routeParams = {
                connectedRyoikiIds: uppperData,
                connectedNenjis: grade,
              }
              return (
                <td key={grade} className={`${tdClassName}${addClassName}`}>
                  {/* <Link to={`${jumpPass}/${grade}`}>{grade}年次</Link> */}
                  <Link to={`${jumpPass}/${grade}`} state={params}>
                    {grade}年次
                  </Link>
                </td>
              )
            }
            return (
              <tr key={aSelector.label} className="text-sm">
                <td className={tdClassName}>
                  {aSelector.label}({aSelector.id})
                </td>
                {grade.map(i => {
                  return render1234(i.data)
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className="text-gray-400 flex justify-end">
        <p className="text-gray-400">
          <small>
            Ver {packageJson.version} Settings {settingsVersion}
          </small>
        </p>
      </div>
    </div>
  )
}
